import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { ProblemIntro } from './components/ProblemIntro';
import { PainPoints } from './components/PainPoints';
import { SystemPitch } from './components/SystemPitch';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Author } from './components/Author';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream pb-20 font-sans text-ink" data-id="element-0" data-mp="28tmfb3zlmcxr">
      <MetaPixel data-id="element-1" data-mp="23vupcfiil0w7" />
      <Hero data-id="element-2" data-mp="23u9vyt7xrnzx" />
      <main data-id="element-3" data-mp="23utbk3a460as">
        <ProblemIntro data-id="element-4" data-mp="23v2td3l0915e" />
        <PainPoints data-id="element-5" data-mp="3ijxq4swlw4ky" />
        <SystemPitch data-id="element-6" data-mp="3ikhaeg9qb525" />
        <Volumes data-id="element-7" data-mp="3iiwasc8k4vxf" />
        <Bonuses data-id="element-8" data-mp="3ijftvw9y1qd1" />
        <Offer data-id="element-9" data-mp="3ihuyy5jpw5en" />
        <Guarantee data-id="element-10" data-mp="3mlj8uuvtnd32" />
        <Testimonials data-id="element-11" data-mp="3ml17jjuay8oa" />
        <Author data-id="element-12" data-mp="3mk852v2dm5by" />
        <Faq data-id="element-13" data-mp="3mjq2lgp4euvl" />
      </main>
      <FinalCta data-id="element-14" data-mp="3rc9f0ac2njyt" />
      <FloatingCta data-id="element-15" data-mp="3rbr9en3irte8" />
      <PurchasePopup data-id="element-16" data-mp="3rdapodp6e4g0" />
    </div>;
}